// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"6d087839","366":"6d087839","591":"4b972020"}[chunkId] + ".chunk.css";
};